var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipBottom = function SvgTipBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    fill: "currentColor",
    viewBox: "2 2 20 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Tip_bottom_svg__filter0_d_4238_2195)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M6 6h12l-6 6z"
  }))));
};
export default SvgTipBottom;